import { GET_ALL_DRIVERS, UPDATE_HIGHLIGHTED_DRIVER, CLEAR_HIGHLIGHTED_DRIVER, UPDATE_DRIVERS, UPDATE_DRIVER_FILTER } from '../constants';

export const getAllDrivers = (drivers) => ({
    type: GET_ALL_DRIVERS,
    drivers
});

export const updateDrivers = (driver) => ({
    type: UPDATE_DRIVERS,
    driver
})

export const updateHighlightedDriver = (driver) => ({
    type: UPDATE_HIGHLIGHTED_DRIVER,
    driver
});

export const clearHighlightedDriver = () => ({
    type: CLEAR_HIGHLIGHTED_DRIVER
})

export const updateDriverFilter = (type) => ({
    type: UPDATE_DRIVER_FILTER,
    action: type
})